import Lookup from 'src/componentes/select2';

const NumeroEtapasLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/NumeroEtapasLookup"
    clearable={false}
    {...rest}
  />
);

export default NumeroEtapasLookup;
